import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { MobileSettingsComponent } from './mobile-settings.component'

export const searchRoutes: Routes = [
  {
    path: 'admin/mobile-settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: {
        only: 'MOBILE_SETTINGS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: MobileSettingsComponent,
      },
    ],
  },
]
